const illegalCharacters = /[^\w\-_\s]/g;

/**
 * In certain contexts component names can't be used as they come.
 * `metrics-js` only allows labels and dimensions to conforming to [\w\-\s_]+ pattern.
 *
 * @see https://product.hubteam.com/docs/frontend/docs/metrics/viewing-metrics.html#why-is-my-metric-data-missing
 * @param name component name
 * @returns safe component name equivalent
 */
export const fmtComponentName = name => name.replace(/:/g, '_').replace(/-+/g, '-').replace(illegalCharacters, '_');